import { render } from "./NotificationPanel.vue?vue&type=template&id=4fb873fd&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=4fb873fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb873fd"]])

export default __exports__